import { Component } from "react";
import { store } from '../../redux/store'


class NpsModal extends Component {
    state = {
        countNum: 0,
    };

    componentDidMount() {
        store.subscribe(() => {
            this.setNpsModal();
        })
    }

    // nps弹窗
    setNpsModal = () => {
        let url = window.location.pathname;
        if(Boolean(store.getState().public.status) && this.state.countNum === 0 && process.env.REACT_APP_ARMS_ENV !== 'local' && !(url.includes('/guide'))) {
            let cur = this.state.countNum + 1;
            this.setState({ countNum: cur })
            let _store = store.getState().public.publicInit
            let nps = _store.other_options.ap_nps;
            let users = _store.shop_data;
            Boolean(window.NPS) && window.NPS.boot({
                accessType: nps.headers['ACCESS-TYPE'],
                accessToken: nps.headers['ACCESS-TOKEN'],
                accessTime: nps.headers['ACCESS-TIME'],
                shop: users.name,
                planDisplayName: users.plan_display_name,
                days: 30,
                installTime: users.created_at,
                language: 'en',
                attribute: 'In-product.Pop-up.Dashboard',
                lastTime: users.lastlogin_time,
                // 样式可以写在这里 
                style: {}
            })
        }
    }

    render() {
        return <></>;
    }
}

export default NpsModal;